import React from 'react';
import { Form } from 'formsy-semantic-ui-react';
import { Button, Icon, Message } from 'semantic-ui-react';
import { connect } from 'react-redux';
import logo from "../../images/logo/logo-full-black.png";
import ModalHeader from './../drive/ModalHeader'
import ModalFooter from './../drive/ModalFooter'
import { dispatch } from '@rematch/core';
import LoadingComponent from "../common/LoadingComponent";
import { singleLinePassword } from '../common/RegexValidation';
import './styles.css';

class UpdatePassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMsg: '',
            password: '',
            showPassword: false,
            confirmPassword: '',
            showConfirmPassword: false,
            otp: '',
            showOtpStep: false,
            timer: 60,
            canResend: false,
            passwordSet: false,
            width: window.innerWidth,
        }
        this.onSubmit = this.onSubmit.bind(this);
        this.handleResize = this.handleResize.bind(this);
    } 
    togglePasswordVisibility = () => {
        this.setState(prev => ({ showPassword: !prev.showPassword }));
    }

    toggleConfirmPasswordVisibility = () => {
        this.setState(prev => ({ showConfirmPassword: !prev.showConfirmPassword }));
    }
    handleResize() {
        const newWidth = window.innerWidth;
        if (newWidth !== this.state.width) {
            this.setState({ width: newWidth });
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        const email = localStorage.getItem("userForVerification");
        dispatch.registerAccount.getUser({email})
    }

    startTimer = () => {
        this.setState({ timer: 60, canResend: false });
        this.interval = setInterval(() => {
            this.setState(prev => {
                if (prev.timer <= 1) {
                    clearInterval(this.interval);
                    return { timer: 0, canResend: true };
                }
                return { timer: prev.timer - 1 };
            });
        }, 1000);
    };

    generateOtp = async () => {
        await dispatch.registerAccount.generateOtp({
            id: this.props.match.params.userid
        });
        this.startTimer();
    };

    async onSubmit(formData) {

        const { history } = this.props;
        try {
            // 👉 Step 1: Generate OTP
            if (!this.state.showOtpStep) {
                await this.generateOtp();
                this.setState({
                    showOtpStep: true,
                    password: formData.password,
                    confirmPassword: formData.confirmPassword,
                    errorMsg: '',
                });
                return;
            }

            // 👉 Step 2: Final submit with OTP
            const payload = {
                id: this.props.match.params.userid,
                password: this.state.password,
                otp: this.state.otp,
                isVerified: true
            };
            await dispatch.registerAccount.changePassword(payload);
            if (this.state.width <= 1024) {
                this.setState({ passwordSet: true });
            } else {
                history.push('/login');
            }
            // dispatch.app.setUser({ ...this.props.user, isVerified: true });
            // if (this.props.user.isPlatformUser) {
            //     history.push(`/app/platform/home`);
            // } else {
            //     if(this.props.user.accounts.some(a => a.role === 'customerAdmin')) {
            //         history.push(`/app/${this.props.user.accounts[0].id}/dashboard`);
            //     } else {
            //         history.push(`/createAccount/${this.props.user.email}`);
            //     }
            // }
        } catch (err) {
            let msg = err.message || 'Something went wrong';
            if (msg.toLowerCase().includes('otp')) {
                msg = 'Invalid or expired OTP. Please try again.';
            }
            this.setState({ errorMsg: msg });
        }
    }

    resendOtp = async () => {
        await this.generateOtp();
        this.setState({ errorMsg: '' });
    };

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
        if (this.interval) clearInterval(this.interval);
    }

    render() {
        const errorLabel = <div className="customErrorLabel" />;
        const {
            showPassword,
            showConfirmPassword,
            password,
            confirmPassword,
            showOtpStep,
            otp,
            timer,
            canResend
        } = this.state;

        const isMobile = this.state.width <= 1024;

        if (this.state.passwordSet && isMobile) {
            return (
                <div className="inner update-password-wrap">
                    <ModalHeader
                        header={<img src={`${logo}`} alt='' />}
                        subHeader="You're all set!"
                    />
                    <div className="ModalContent">
                        <div className="error_text2 clr-green">
                            <Icon name="check circle outline" /> Password Set Successfully!
                        </div>
                        <p className="ev-welcome">
                            Your credentials have been set up. Here's what to do next:
                        </p>
                        <div className="ev-next-step">
                            <div className="ev-next-step-label">
                                <Icon name="desktop" /> Next Step
                            </div>
                            Open this application on your <strong>desktop or laptop</strong> and login with your new password to get started.
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="inner update-password-wrap">
                <LoadingComponent active={this.props.ChgPassAsyncFunc} message="Loading..." />
                <ModalHeader
                    header={<img src={`${logo}`} alt='' />}
                    subHeader={`Welcome ${this.props.user && this.props.user.firstName ? this.props.user.firstName : ''}!`}
                />

                <div className="ModalContent">
                    <p className="clr-green">Setup your Credentials!</p>
                    <p>Please setup your password to continue</p>

                    {this.state.errorMsg && (
                        <Message error content={this.state.errorMsg} />
                    )}

                    <Form
                        noValidate
                        error
                        className="loginform"
                        onValidSubmit={this.onSubmit}
                    >

                        {/* PASSWORD */}
                        <Form.Input
                            name="password"
                            label="New Password"
                            icon="key"
                            iconPosition="left"
                            type={showPassword ? "text": "password"}
                            placeholder="New Password"
                            required
                            value={password}
                            errorLabel={errorLabel}
                            validations={{ minLength: 8, matchRegexp:singleLinePassword,
                                sameAsEmail: (values, value) => {
                                if (this.props.user && this.props.user.email && value) {
                                    return value.toLowerCase() !== this.props.user.email.toLowerCase();
                                }
                                return true; 
                            }}}
                            validationErrors={{
                                minLength: 'Minimum of 8 characters',
                                matchRegexp: 'Space not allowed',
                                isDefaultRequiredValue: 'New Password is required',
                                sameAsEmail: 'Password cannot be the same as your email address',
                            }}
                            id="newPassword"
                            action={<Icon
                                name={showPassword ? 'eye' : 'eye slash'}
                                link
                                onClick={this.togglePasswordVisibility}
                                style={{left: "auto", right: "1px"}}
                              />}
                        />
                        <Form.Input
                            name="confirmPassword"
                            label="Confirm Password"
                            icon="key"
                            iconPosition="left"
                            type={showConfirmPassword ? "text": "password"}
                            value={confirmPassword}
                            placeholder="Confirm New Password"
                            required
                            errorLabel={errorLabel}
                            validations="equalsField:password"
                            validationErrors={{
                                equalsField: 'Should be same as new Password',
                                isDefaultRequiredValue: 'Confirm Password is required',
                            }}
                            id="confirmPassword"
                            action={<Icon
                                name={showConfirmPassword ? 'eye' : 'eye slash'}
                                link
                                onClick={this.toggleConfirmPasswordVisibility}
                                style={{left: "auto", right: "1px"}}
                              />}
                        />

                        {/* OTP STEP */}
                        {showOtpStep && (
                            <div>
                                <Form.Input
                                    name="otp"
                                    label="Enter One-Time Password (OTP)"
                                    placeholder="6 digit One-Time Password (OTP)"
                                    value={otp}
                                    required
                                    onChange={(e, { value }) => this.setState({ otp: value })}
                                    validations={{
                                        isNumeric: true,
                                        minLength: 6,
                                        maxLength: 6
                                    }}
                                    validationErrors={{
                                        isNumeric: 'One-Time Password (OTP) must be numeric',
                                        minLength: 'One-Time Password (OTP) must be 6 digits',
                                        maxLength: 'One-Time Password (OTP) must be 6 digits',
                                        isDefaultRequiredValue: 'One-Time Password (OTP) is required'
                                    }}
                                />
                                <span style={{ display: 'block', fontSize: '12px', color: '#666', margin: '0px 0 10px 0', fontFamily: 'sans-serif' }}>
                                  Please check your email for the One-Time Password (OTP).
                                </span>

                                <div style={{ marginBottom: '10px' }}>
                                    {canResend ? (
                                        <Button type="button" basic size="small" onClick={this.resendOtp}>
                                            Resend OTP
                                        </Button>
                                    ) : (
                                        <span>Resend One-Time Password (OTP) in {timer}s</span>
                                    )}
                                </div>
                            </div>
                        )}

                        <Button floated='right' className="button-submit" type="submit">
                            {showOtpStep ? 'Confirm' : 'Next'}
                        </Button>
                        <br /><br />
                    </Form>
                </div>

                <ModalFooter />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.registerAccount.userForVerification,
        ChgPassAsyncFunc: state.loading.effects.registerAccount.changePassword
    };
}

const connectedUpdatePassword = connect(mapStateToProps)(UpdatePassword);

export { connectedUpdatePassword as UpdatePassword };